import { ChangeEvent, useState } from "react";
import UnForm from "../../../../../Components/Form";
import {
    ITwillioBase,
    ITwillioWhatsAppAuthenticationType,
} from "../../../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import { SendTemplateTwilioController } from "../../../../../Controllers/HelpDesk/GestaoTemplate/GestaoTemplateController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { useHistory, useParams } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ACESSOS } from "../../../../../Routes/Acessos";

interface URLParams {
    name?: string;
    contentType?: string;
}

// Type whatsapp_authentication
export default function ContentType8() {
    const { name } = useParams<URLParams>();
    const history = useHistory();

    const [bodyChecked, setBodyChecked] = useState(false);
    const [footerChecked, setFooterChecked] = useState(false);
    const [expirationTime, setExpirationTime] = useState("");
    const [buttonText, setButtonText] = useState("");
    const [expirationTimeError, setExpirationTimeError] = useState("");
    const [buttonTextError, setButtonTextError] = useState("");

    const handleExpirationTimeChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setExpirationTime(value);
            if (
                value.length > 2 ||
                parseInt(value, 10) < 1 ||
                parseInt(value, 10) > 90
            ) {
                setExpirationTimeError(
                    "Por favor, digite um número entre 1 e 90"
                );
            } else {
                setExpirationTimeError("");
            }
        }
    };

    const handleButtonTextChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setButtonText(value);
        if (value.length > 20) {
            setButtonTextError("Tamanho maior que 20");
        } else {
            setButtonTextError("");
        }
    };

    const { execute: SendTemplateTwilio, loading: SendTemplateTwilioLoading } =
        useAsyncCallback(SendTemplateTwilioController);

    function handleWppAuthentication(
        formData: ITwillioBase<ITwillioWhatsAppAuthenticationType>
    ) {
        const requestBody = {
            ...formData,
            friendly_name: name ?? "",
            language: "pt_BR",
        };

        const jsonString = JSON.stringify(requestBody);

        SendTemplateTwilio(jsonString, "TEXT").then(() => {
            setBodyChecked(false);
            setFooterChecked(false);
            setExpirationTime("");
            setButtonText("");
            setExpirationTimeError("");
            setButtonTextError("");

            history.push(ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH);
        });
    }

    return (
        <UnForm handleSubmit={handleWppAuthentication}>
            <div className="flex flex-column mb-3">
                <div>Body</div>
                <div className="d-flex align-items-center">
                    <UnForm.Input
                        name="types.twilio/whatsapp_authentication.add_security_recommendation"
                        type="checkbox"
                        checked={bodyChecked}
                        onChange={(e) => setBodyChecked(e.target.checked)}
                    />
                    {bodyChecked && (
                        <span>Adicionar Recomendação de Segurança</span>
                    )}
                </div>
            </div>
            <div className="flex flex-column mb-3">
                <div>Footer</div>
                <div>
                    <input
                        type="checkbox"
                        checked={footerChecked}
                        onChange={(e) => setFooterChecked(e.target.checked)}
                    />
                    {footerChecked && <span>Tempo de Expiração do Código</span>}
                </div>
                {footerChecked && (
                    <div>
                        <UnForm.Input
                            name="types.twilio/whatsapp_authentication.code_expiration_minutes"
                            type="text"
                            value={expirationTime}
                            onChange={handleExpirationTimeChange}
                            placeholder="Digite um número inteiro entre 1 e 90 minutos"
                            className="form form-control"
                        />
                        <div
                            className={`d-flex ${
                                expirationTimeError &&
                                expirationTimeError.length > 0
                                    ? "justify-content-between"
                                    : "justify-content-end"
                            } `}
                        >
                            {expirationTimeError &&
                                expirationTimeError.length > 0 && (
                                    <div style={{ color: "red" }}>
                                        {expirationTimeError}
                                    </div>
                                )}
                            <div>{expirationTime.length}/2</div>
                        </div>
                    </div>
                )}
            </div>
            <div className="card p-3 mb-3">
                <div className="p-2">
                    <div className="mb-1">
                        <label>Tipo de ação</label>
                        <UnForm.Select
                            name="types.twilio/whatsapp_authentication.actions.type"
                            className="form-control"
                        >
                            <option value="COPY_CODE">Copy Code</option>
                        </UnForm.Select>
                    </div>
                    <div className="mb-1">
                        <label>Texto do Botão</label>
                        <UnForm.Input
                            name="types.twilio/whatsapp_authentication.actions.copy_code_text"
                            className="form-control"
                            value={buttonText}
                            onChange={handleButtonTextChange}
                            placeholder="Digite o texto do botão aqui"
                        />
                        <div
                            className={`d-flex ${
                                buttonTextError && buttonTextError.length > 0
                                    ? "justify-content-between"
                                    : "justify-content-end"
                            } `}
                        >
                            {buttonTextError && (
                                <div style={{ color: "red" }}>
                                    {buttonTextError}
                                </div>
                            )}
                            <div>{buttonText.length}/20</div>
                        </div>
                    </div>
                </div>
            </div>

            <hr className="my-5 " />

            <div className="d-flex justify-content-start">
                <div>
                    <UnForm.SubmitButton
                        icon={faPlus}
                        disabled={SendTemplateTwilioLoading}
                        loading={SendTemplateTwilioLoading}
                        wrapperClassName="m-0"
                        loadingSize="sm"
                        color="success"
                    >
                        Criar
                    </UnForm.SubmitButton>
                </div>
                <div>
                    <button
                        className="btn btn-secondary ml-2"
                        type="button"
                        onClick={() => {
                            history.push(
                                ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES_TWILIO
                                    .DS_PATH
                            );
                        }}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </UnForm>
    );
}
